var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "msg-subscr-msanage" }, [
      _c("div", { staticClass: "hint block mb10" }, [
        _c("div", { staticClass: "title" }, [_vm._v("温馨提示")]),
        _vm._v(" "),
        _c("p", [_vm._v("逐条检查：一条一条的检查，因数据较多花费时间较长")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "hint block mb10" }, [
        _c("p", [
          _vm._v("逐条检查导入：一条一条的检查并导入，因数据较多花费时间较长")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "hint block" }, [
        _c("p", [_vm._v("导入excel文件的单元格格式推荐使用常规或文本")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "message-body mt10" }, [
        _c("ul", { staticClass: "native-table" }, [
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-th",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("列名")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table-th", staticStyle: { width: "120px" } },
              [_vm._v("是否必填")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-th",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("其他要求")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-th" }, [_vm._v("不符合要求的结果")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("名称")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("必填，可在系统中手动输入")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("定义编码")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("可在系统中手工输入，商户唯一")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("分类")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [
                _vm._v(
                  "资产分类与商品分类选填一种（可在系统中进行选择以系统为准）,填写资产分类后会带出关联的商品分类"
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("品牌")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [
                _vm._v(
                  "资产品牌与商品品牌选填一种（可在系统中进行选择以系统为准）,填写资产品牌后会带出关联的商品品牌"
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("型号")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("不能超过30个字符且[型号]+[规格]不能超过60个字符")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("规格")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("不能超过45个字符且[型号]+[规格]不能超过60个字符")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("组装件描述全称")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("可在系统中手动输入，默认=名称+型号+规格")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("单位")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [
                _vm._v(
                  "系统对每类资产有一个默认单位，不填写的情况下直接使用此单位。商户应对每类每批次定一个固定单位"
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("-")])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-028968f1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-028968f1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/asmblAcc/AsmblAccDefFormatExpl.vue
// module id = 2439
// module chunks = 0